import { IntroductionPage } from '@resurs-internal/deposits-app-components';
import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { CountryContext } from '@/contexts';
import { useCampaignCode, useProducts } from '@/hooks';

export const HomeView = () => {
  const { country } = useContext(CountryContext);
  const navigate = useNavigate();
  const { productCode } = useParams();
  const { appendCampaignCode } = useCampaignCode();
  const { isLoading, productFromCode } = useProducts(country);

  useEffect(() => {
    if (!isLoading && productCode) {
      const validProduct = productFromCode(productCode);

      if (!validProduct) {
        navigate(appendCampaignCode('/'), { replace: true });
      }
    }
  }, [isLoading, productCode, productFromCode, navigate, appendCampaignCode]);

  const navigateNext = () => {
    if (!productCode) {
      navigate(appendCampaignCode('/choose-account-type'));

      return;
    }

    if (isLoading || productFromCode(productCode)) {
      navigate(appendCampaignCode(`/choose-account-type/${productCode}`));

      return;
    }

    navigate(appendCampaignCode('/choose-account-type'));
  };

  return <IntroductionPage navigateNext={navigateNext} />;
};
